<template>
    <v-layout>
        <v-flex>
            <v-card>
                <v-toolbar>
                    <StudentPickerAutocomplete
                            v-model="selectedStudentId"
                            :useQueryString="false">
                    </StudentPickerAutocomplete>

                    <v-btn color="info"
                           :disabled="!selectedStudentId"
                           @click="navigateToTestStart">Begin test &gt;&gt;</v-btn>

                </v-toolbar>

                <v-card-title>
                    <h3>Total questions: {{assessment && assessment.questions && assessment.questions.length ?
                        assessment.questions.length : 0}}</h3>
                </v-card-title>

                <v-list v-if="questions && questions.length" two-line>
                    <template v-for="(question, index) in questions">
                        <v-list-tile
                                :key="question.id + question.text"
                                avatar
                                ripple
                        >
                            <v-list-tile-avatar>
                                <v-icon>help</v-icon>
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <v-list-tile-title><span class="text--secondary">Question: </span>{{ question.text }}</v-list-tile-title>
                                <v-list-tile-sub-title>Answer type: <span class="text--primary">{{getAnswerTypeDisplayString(question)}}</span></v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-divider
                                v-if="index + 1 < questions.length"
                                :key="index"
                        ></v-divider>
                    </template>
                </v-list>

            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import Assessment from "./Assessment";
    import StudentPickerAutocomplete from "../components/StudentPickerAutocomplete";
    export default {
        components: {StudentPickerAutocomplete, Assessment},

        props: {
            id: 0,
        },
        data: function () {
            return {
                selectedStudentId: null,
                assessment: null,
                questions: []
            }
        },

        methods: {
            navigateToTestStart() {
                let options = {
                    name: 'do-test-for-student',
                    params: {
                        studentId: this.selectedStudentId,
                        testId: this.$router.currentRoute.params['id']
                    }
                };
                this.$router.push(options);
            },
            getAnswerTypeDisplayString(question) {
                if (question.answerType === 'passfail') {
                    return 'Knows/Doesn\'t know';
                }
                else if (question.answerType === 'multichoice') {
                    return 'Multiple choice';
                }
                return 'Unknown';
            }
        },
        mounted() {
            this.$store.dispatch('getAssessments', {
                ids: [+this.$router.currentRoute.params['id']]
            }).then((aList) => {
                if (!aList || !aList.length) {
                    return Promise.reject('Tests were not found');
                }
                this.assessment = aList[0] || null;

                // set toolbar title
                this.$store.commit('setToolbarOptions', {
                    title: 'Test',
                    subTitle: (this.assessment && this.assessment.title) ? this.assessment.title : 'Unknown',
                    hideSearch: false,
                    backButtonRoute: {name: 'tests'}
                });

                if (this.assessment) {
                    this.$store.dispatch('getQuestions', {ids: this.assessment.questions.map(q => q.id)})
                        .then(qList => {
                            this.questions = qList;
                        });
                }
            });
        }
    }
</script>
